import { type FunctionComponent, useEffect, useState } from "react";
import { useShopfrontSelector } from "../../_Bootstrap/hooks";
import { determineDataSource } from "../../Data/DataStores/DataSource";
import FourZeroThree from "../../Routes/Errors/403";
import { Permissions } from "../../Utilities/Domain/Users/Permissions";
import { TitleRoute, type TitleRouteProps } from "./TitleRoute";

interface PrivateRouteProps extends TitleRouteProps {
    permissions: Array<string>;
    oneOf?: boolean;
}

export const PermissionRoute: FunctionComponent<PrivateRouteProps> = ({
    oneOf,
    permissions,
    element,
    ...routeProps
}) => {
    if(typeof oneOf === "undefined") {
        oneOf = false;
    }

    const user = useShopfrontSelector(state => state.user?.id || null);
    const [ hasPermission, setHasPermission ] = useState(true);

    useEffect(() => {
        if(!user) {
            return;
        }

        determineDataSource()
            .then(source => source.users.get(user))
            .then(user => {
                let hasPermission: boolean | undefined;

                if(user.permissions === null) {
                    hasPermission = true;
                } else if(Array.isArray(user.permissions)) {
                    hasPermission = false;
                } else if(!oneOf) {
                    for(let i = 0, l = permissions.length; i < l; i++) {
                        if(!Permissions.checkPermissions([ permissions[i] ], user.permissions)) {
                            hasPermission = false;
                            break;
                        }
                    }

                    if(typeof hasPermission === "undefined") {
                        hasPermission = true;
                    }
                } else {
                    for(let i = 0, l = permissions.length; i < l; i++) {
                        if(Permissions.checkPermissions([ permissions[i] ], user.permissions)) {
                            hasPermission = true;
                            break;
                        }
                    }

                    if(hasPermission !== true) {
                        hasPermission = false;
                    }
                }

                setHasPermission(hasPermission);
            })
            .catch(() => {
                setHasPermission(true);
            });
    }, [ user, oneOf, permissions ]);

    return (
        <TitleRoute
            {...routeProps}
            element={hasPermission ? element : <FourZeroThree permissions={permissions} />}
        />
    );
};
